import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import { isEmpty } from 'lodash'
import { toast } from 'react-toastify'
import { SortType } from 'rsuite-table/lib/@types/common'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import { ItemType, StateParamsModel } from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import * as updateNotesRedux from 'src/app/modules/rates/components/updateNotes'
import { IUpdateNotesState } from 'src/app/modules/rates/components/updateNotes'
import * as setting from 'src/app/modules/siteSettings/components/settings'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import * as memberType from '../index'
import AddMemberType from './AddMemberType'
import AddUpdateNotes from './AddUpdateNotes'

const MemberTypeComponent = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const {
    data,
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    deleteSuccess,
    memberTypeList,
    sortMemberTypeData,
  } = useSelector((state: any) => state.memberType)
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
    orderBy: 'order',
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openSortModal, setOpenSortModal] = useState(false)
  const [memberId, setMemberId] = useState<any>('')
  const updateNotes: IUpdateNotesState = useSelector((state: any) => state.updateNotes)
  const [addNotice, setAddNotice] = useState(false)
  const [actionType1, setActionType1] = useState('Add')
  const [actionTypeNotice, setActionTypeNotice] = useState('AddNote')


  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)

  const settingType: any = settingTypeData?.data?.setting
    ?.filter((item: any) => item.name === 'updateNote')
    .map((item: any) => item)

  useEffect(() => {
    dispatch(setting.actions.getSettingType())
  }, [])


  const handleCloseNotice = () => setAddNotice(false)
  useEffect(() => {
    dispatch(updateNotesRedux?.actions.getUpdateNotes())
  }, [])

  useEffect(() => {
    const updateNoteList = updateNotes?.data?.excerptRateCategory?.filter(
      (item: any) => item.name === 'Management Commitee'
    )
    updateNoteList?.length > 0 && setMemberId(updateNoteList[0]?.id)
  }, [updateNotes])

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const enableMemberTypeData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(memberType.actions.enableMemberType(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableMemberTypeData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(memberType.actions.disableMemberType(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({ rowData, dataKey, ...props }: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group' data-cy="link-group-member-type">
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' data-cy="single-member-type-edit-button" speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              icon={<Edit2 />}
              data-cy='edit-button'
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' data-cy="single-member-delete-button" speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let branchId = [rowData.id]
                setCheckedValues(branchId)
              }}
              icon={<TrashIcon />}
              data-cy='delete-button'
            />
          </Whisper>
        </CheckPermissions>
        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Status</Tooltip>}>
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.status}
            onClick={() => handleToggleAction(rowData)}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleAddNotice = () => {
    setEditCheckedData({})
    setAddNotice(true)
    setActionType1('Add Note')
  }

  const handleToggleAction = (data: { [key: string]: string }) => {
    data?.status
      ? dispatch(memberType.actions.singleDisableMemberType({ id: data.id }))
      : dispatch(memberType.actions.singleEnableMemberType({ id: data.id }))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Name',
      dataKey: 'name',
      flexGrow: 1,
      cell: <Cell dataKey='name' />,
      sortable: true,
    },
    {
      label: 'Slug',
      dataKey: 'slug',
      flexGrow: 1,
      cell: <Cell dataKey='slug' />,
      sortable: true,
    },

    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm' data-cy='active-button'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm' data-cy='in-active-button'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  useEffect(() => {
    dispatch(memberType.actions.getMemberType(params))
  }, [params])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Member type deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Member type enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Member type disabled successfully')
    }
    handleChecked([])
    dispatch(memberType?.actions.getMemberType(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Member type enabled successfully')
    }
    if (singleDisableSuccess) {
      toast.success('Member type disabled successfully')
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const memberTypeData = data?.memberType
    ? data?.memberType?.map((item: any, i: number) => ({
      sn: (params?.page - 1) * params?.limit + (i + 1),
      description: item.description,
      description_np: item.description_np,
      id: item.id,
      name: item.name,
      name_np: item.name_np,
      order: item.order,
      slug: item.slug,
      status: item.status,
    }))
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({ ...params, orderBy: dataKey, order: sortType })
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let memberTypeId = checkedValues?.map((value) => ({ id: value }))
    dispatch(memberType?.actions?.deleteMemberType(memberTypeId))
    handleAlertClose()
  }

  const handleRefresh = () => {
    dispatch(memberType.actions.getMemberType(params))
  }

  const handleGetAllData = () => {
    setParams({ ...params, limit: data?.meta?.total })
    dispatch(memberType.actions.getMemberType(params))
  }

  const handleSubmitSort = (data: Array<ItemType>) => {
    let body = {
      memberTypeId: data?.map((item) => ({ id: item?.keyId })),
    }
    dispatch(memberType.actions.sortMemberType(body))
  }

  useEffect(() => {
    if (!isEmpty(sortMemberTypeData) && success) {
      toast.success('Member type sorted successfully')
      dispatch(memberType.actions.sortMemberTypeReset())
      setParams({ ...params, limit: 10 })
      dispatch(memberType.actions.getMemberType(params))
      setOpenSortModal(false)
    }
  }, [sortMemberTypeData, success])

  return (
    <>
      <div className='shadow p-3 bg-white rounded' data-cy='shadow-member-type' >
        {addNotice && (
          <AddUpdateNotes
            open={addNotice}
            forexId={memberId}
            handleClose={handleCloseNotice}
            actionType={actionTypeNotice}
            editSelectedData={editSelectedData}
          />
        )}
        <DesignComponent
          moduleName='Member Type'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          exportShow={false}
          importShow={false}
          enableMultiple={enableMemberTypeData}
          disableMultiple={disableMemberTypeData}
          data={memberTypeData}
          sortShow={true}
          sortButtonName='Sort'
          handleSubmitSort={handleSubmitSort}
          handleGetAllData={handleGetAllData}
          openSortModal={openSortModal}
          setOpenSortModal={setOpenSortModal}
          loading={loading}
          addNoteMemberTypeShow={settingType[0]?.value === '1' ? true : false}
          handleAddNotice={handleAddNotice}
        />

        <div className='datatable' data-cy='datatable-member-type'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={columns}
            data={memberTypeData}
            checkedValues={checkedValues}
            showLoading={loading}
            handleSort={handleSort}
            data-cy='r-suit-table'
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({ ...params, page: value })}
            onChangeLimit={handleChangeLimit}
            data-cy='cms-pagination'
          />
          {open && (
            <AddMemberType
              open={open}
              params={params}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          )}
        </div>

        {/* Delete Modal */}
        {alertOpen &&
          (!isEmpty(checkedValues) ? (
            <DeleteModal
              handleClick={() => handleDelete()}
              isOpen={alertOpen}
              handleClose={() => handleAlertClose()}
            />
          ) : (
            toast.error('No data selected') && setAlertOpen(false)
          ))}
      </div>
    </>
  )
}

export default MemberTypeComponent
